import { Injectable } from '@angular/core';

export interface IExecutionDateState {
	date: Date | null;
	updateForAll: boolean;
}

@Injectable()
export class SendExecutionService {
	scheduled: IExecutionDateState = {
		date: null,
		updateForAll: false
	};
	deadline: IExecutionDateState = {
		date: null,
		updateForAll: false
	};

	clearData(): void {
		this.scheduled = {
			date: null,
			updateForAll: false
		};
		this.deadline = {
			date: null,
			updateForAll: false
		};
	}
}
